// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headerDivViewTwo {
    font-size: 20px;
    color: grey;
    font-family: 'Gilory-Bold';
    position: absolute;
    margin-top: -3%;
}

.updatedImagesContainer {
    display: flex;
    margin-top: 11%;
    width: 1300px
}

.approvedImagesContainer {
    display: flex;
    margin-top: 1%;
    width: 1300px
}

.buttonDiv {
    margin-top: 1%;
}

.profileStatusTag {
    display: inline-block;
    margin-left: 12px;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 14px;
    color: white;
}

.profileStatusTag.approved { background-color: #64a65b; }
.profileStatusTag.disapproved { background-color: #d95359; }

.nextViewTwo {
    width: 36px;
    height: 30px;
    margin-top: 16px;
    margin-left: 26px;
    cursor: pointer;
}

.previousViewTwo {
    width: 36px;
    height: 30px;
    margin-top: 16px;
    margin-right: 26px;
    cursor: pointer;
}

.likeInactive {
    color: green;
    background-color: white;
    cursor: pointer;
}

.passInactive {
    color: red;
    background-color: white;
    cursor: pointer;
}

.likeActive {
    color: white;
    background-color: rgb(100, 166, 91);
    cursor: pointer;
}

.passActive {
    color: white;
    background-color: rgb(217, 83, 89);
    cursor: pointer;
}

.dragAndDropDiv {
    width: 250px;
    height: 250px;
    margin-right: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/tabs/image/View2.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,WAAW;IACX,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,YAAY;AAChB;;AAEA,6BAA6B,yBAAyB,EAAE;AACxD,gCAAgC,yBAAyB,EAAE;;AAE3D;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mCAAmC;IACnC,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB","sourcesContent":[".headerDivViewTwo {\n    font-size: 20px;\n    color: grey;\n    font-family: 'Gilory-Bold';\n    position: absolute;\n    margin-top: -3%;\n}\n\n.updatedImagesContainer {\n    display: flex;\n    margin-top: 11%;\n    width: 1300px\n}\n\n.approvedImagesContainer {\n    display: flex;\n    margin-top: 1%;\n    width: 1300px\n}\n\n.buttonDiv {\n    margin-top: 1%;\n}\n\n.profileStatusTag {\n    display: inline-block;\n    margin-left: 12px;\n    padding: 4px 10px;\n    border-radius: 12px;\n    font-size: 14px;\n    color: white;\n}\n\n.profileStatusTag.approved { background-color: #64a65b; }\n.profileStatusTag.disapproved { background-color: #d95359; }\n\n.nextViewTwo {\n    width: 36px;\n    height: 30px;\n    margin-top: 16px;\n    margin-left: 26px;\n    cursor: pointer;\n}\n\n.previousViewTwo {\n    width: 36px;\n    height: 30px;\n    margin-top: 16px;\n    margin-right: 26px;\n    cursor: pointer;\n}\n\n.likeInactive {\n    color: green;\n    background-color: white;\n    cursor: pointer;\n}\n\n.passInactive {\n    color: red;\n    background-color: white;\n    cursor: pointer;\n}\n\n.likeActive {\n    color: white;\n    background-color: rgb(100, 166, 91);\n    cursor: pointer;\n}\n\n.passActive {\n    color: white;\n    background-color: rgb(217, 83, 89);\n    cursor: pointer;\n}\n\n.dragAndDropDiv {\n    width: 250px;\n    height: 250px;\n    margin-right: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
